// extracted by mini-css-extract-plugin
export default {"unreadLight":"Chats_unreadLight__fE8+E","unreadDark":"Chats_unreadDark__4SxeS","messagePreview":"Chats_messagePreview__LKKrE"};